import React from 'react';
import { useHistory } from 'react-router-dom';
import OverlaySpinner from 'components/spinners/OverlaySpinner';
import { SecondaryButton } from 'components/v2/buttons';
import { confirmDelete } from 'components/v2/confirm-dialog/confirmDelete';
import EpdRoutes from 'routes/EpdRoutes';
import { useDeleteToolMutation } from 'services/api/adminToolsQueriesAndMutations';
import { PatchedToolForAdminModel } from 'types/admin-tools/PatchedToolForAdminModel';

interface Props {
  toolData: PatchedToolForAdminModel;
}

const AdminEditToolActionButtons: React.FC<Props> = ({ toolData }) => {
  const deleteToolMutation = useDeleteToolMutation(toolData.id);
  const history = useHistory();

  return (
    <>
      {toolData.versions.length === 0 && (
        <SecondaryButton
          label="Delete"
          onClick={() => {
            confirmDelete({
              caption: 'Are you sure you want to delete the tool?',
              description: 'All filled-in information will be removed.',
              onConfirm: () =>
                deleteToolMutation.mutate(void 0, {
                  onSuccess() {
                    history.push(EpdRoutes.admin.tools.search);
                  },
                }),
            });
          }}
          outlined
        />
      )}

      {deleteToolMutation.isPending && <OverlaySpinner />}
    </>
  );
};

export default AdminEditToolActionButtons;
